/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Effect Map Existing Missions component
Author: Deimos Space UK

Version: 1.0
*/


import React, { useState, useEffect } from "react";
import { Row, Card, CardBody, Dropdown, DropdownMenu, DropdownToggle,DropdownItem , Col, Alert} from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';
import { getImage } from "../../../../api/api";
export default function EffectMapExistingMissions() {
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [orbitalRegion, setOrbitalRegion] = useState('LEO')
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [effectMapOption, setEffectMapOption] = useState('collision');
  const [effectMapImages, setEffectMapImages] = useState();
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
 const toggle2 = () => setDropdownOpen2((prevState) => !prevState);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const options = [
    {
      value: 'collision',
      label: 'Collision effect map'
    }, {
      value: 'explosion',
      label: 'Explosion effect map'
    }, {
      value: 'probability',
      label: 'Probability of collision'
    }, {
      value: 'distribution',
      label: 'Debris distribution map'
    }
  ]
  useEffect(() => {
    setError(false)
    setLoading(true)
    if((effectMapOption === 'probability' || effectMapOption === 'distribution') && (orbitalRegion === 'GEO')){
      setOrbitalRegion('LEO')
    }else{

  
      getImage(`/api/maps/map_by_region?map_type=${effectMapOption}&region=${orbitalRegion}`)
        .then((data) => {
          if(data[1]){
          setEffectMapImages(URL.createObjectURL(data[0]))
          setLoading(false)
          setError(false)
        } else{ 
          setLoading(false)
          setError(true)
        }
        })
        .catch((error) => {
          console.log(error)
          setLoading(false)
          setError(true)
        })
    }
    
  }, [effectMapOption, orbitalRegion]);

  const getLabel = () => {
    if(orbitalRegion === 'MEO2'){
      return 'High MEO'
    }
    if(orbitalRegion === 'MEO1'){
      return 'Low MEO'
    }
    return orbitalRegion
  }
  return (
    <Card className="widget-flat">
      <CardBody>
        <Row >
          <h4 style={{ color: '#003247' }} className="header-title float-left col " >MAPS</h4>
          <Col>
              <Dropdown className="float-right" isOpen={dropdownOpen} toggle={toggle} >
                <DropdownToggle style={{ background: "#003247" }} caret>{options.find(o => o.value === effectMapOption).label}</DropdownToggle>
                <DropdownMenu  >
                  <DropdownItem onClick={() => setEffectMapOption('collision')}>Collision effect map</DropdownItem>
                  <DropdownItem onClick={() => setEffectMapOption('explosion')}>Explosion effect map</DropdownItem>
                  {
                    orbitalRegion !== 'GEO' &&
                    <>
                    <DropdownItem onClick={() => setEffectMapOption('probability')}>Probability of collision</DropdownItem>
                    <DropdownItem onClick={() => setEffectMapOption('distribution')}>Debris distribution map</DropdownItem>
                    </>
                  }
                    </DropdownMenu>
              </Dropdown>

            </Col>
          <Dropdown isOpen={dropdownOpen2} toggle={toggle2} >
            <DropdownToggle style={{ background: '#003247' }} className="float-right" caret>{getLabel()}</DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => setOrbitalRegion('LEO')}>LEO</DropdownItem>
              <DropdownItem onClick={() => setOrbitalRegion('MEO1')}>Low MEO</DropdownItem>
              <DropdownItem onClick={() => setOrbitalRegion('MEO2')}>High MEO</DropdownItem>
              {
                effectMapOption !=='probability' && effectMapOption !=='distribution' &&
                <DropdownItem onClick={() => setOrbitalRegion('GEO')}>GEO</DropdownItem>
              }
              
              <DropdownItem onClick={() => setOrbitalRegion('GTO')}>GTO</DropdownItem>
            </DropdownMenu>
          </Dropdown>
         
        </Row>
        <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>

{error ?
  (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
      <Alert color="warning">
        <h4 className="alert-heading">No data available</h4>
        <p>
          There is no data available for this mission.
        </p>
      </Alert>
    </div>
  )
  :
  (<Col xs={12} style={{ display: 'flex', justifyContent: 'center', }}>
    {
      loading ?
        (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
            <Spinner animation="border" role="status"></Spinner>
          </div>
        )
        :
        (
          <img
            src={effectMapImages}
            className="img-fluid"
            style={{ maxWidth: '80%', }}
            alt="EffectMap-img"
          />
        )
    }

  </Col>
  )}
</Row>
      </CardBody>
    </Card>
  );
}